import React from "react";
import styled from "@emotion/styled";
import { physioMeTabletBreakpoint } from "@ui/style";
import { useDimensions } from "@ui/hooks/use-dimensions";
import { exerciseFilterManager } from "@core/service-container";
import { BaseExercise } from "@domain/exercise/exercise";
import { CrossButton } from "@ui/pages/exercise/components/cross-button";
import { useExercisePage } from "@ui/pages/exercise/hooks/use-exercise-page";

interface SelectedExerciseCardProps {
	exercise: BaseExercise;
	className?: string;
}

export const SelectedExerciseCard: React.FC<SelectedExerciseCardProps> = ({ exercise, className }) => {
	const { isDesktop } = useDimensions();
	const { openSelectedExerciseDetailsModal } = useExercisePage();

	return (
		<Container className={className}>
			{isDesktop && (
				<StyledCrossButton
					onClick={() => exerciseFilterManager.updateSelectedExercise(exercise, false)}
					className="cross-button"
				/>
			)}
			<ThumbnailContainer
				onClick={() => openSelectedExerciseDetailsModal(exercise)}
				src={exercise.thumbnails.mediumThumbnailUrl}
				className="thumbnail"
			/>
		</Container>
	);
};

const Container = styled.div`
	display: inline-block;
	position: relative;

	.cross-button:hover + .thumbnail {
		border-color: var(--rejection);
	}

	.cross-button:hover + .thumbnail::after {
		opacity: 0.3;
	}
`;

const ThumbnailContainer = styled.div<{ src: string | undefined }>`
	background-image: url("${({ src }) => src}");
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	border: 1px solid var(--primary-10);
	border-radius: 8px;
	height: 64px;
	width: 64px;
	position: relative;
	cursor: pointer;

	&::after {
		content: "";
		position: absolute;
		inset: 0;
		border-radius: 8px;
		background-color: var(--rejection);
		opacity: 0;
	}
`;

const StyledCrossButton = styled(CrossButton)`
	position: absolute;
	top: 0;
	right: 0;
	z-index: 10;

	@media ${physioMeTabletBreakpoint} {
		display: none;
	}
`;
